import { ReactElement, ReactNode } from 'react';
import classNames from 'classnames';

import PageSkeleton from '^components/common/PageSkeleton';

import styles from './styles.module.scss';

export interface ISkeletonProviderProps {
  className?: string;
  isLoaderShown?: boolean;
  children: ReactNode;
}

const SkeletonProvider = ({ isLoaderShown = false, className, children }: ISkeletonProviderProps): ReactElement => (
  <div className={classNames(styles.wrap, className)}>
    {isLoaderShown
      ? <PageSkeleton />
      : (
        <>
          { children }
        </>
      )}
  </div>
);

export default SkeletonProvider;
